var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-flex align-center rocky--text",attrs:{"href":_vm.href,"target":"_blank"}},[_c('rir-icon',{staticClass:"mr-1",attrs:{"icon":"link"}}),_vm._v(" Ссылка на тестирование ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }